import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isShiftBiddingFeatureEnabledSelector = createSelector(
  getUserPermissions,
  (userPermissions) => !!userPermissions?.SHIFT_BIDDING?.access,
);
